export default {
  APP: {
    NAME: 'Carriers',
    COMPANY: 'Freightforge'
  },
  ACTIONS: {
    RETRY: 'Retry',
    EDIT: 'Edit',
    VISUALIZE: 'Visualize'
  },
  CARRIERS_DETAIL: {
    TITLE: 'Details'
  },
  CARRIERS_EDIT: {
    TITLE: 'Edition'
  },
  RATE_REQUESTS_LIST: {
    TITLE: 'Rate requests'
  },
  CONTRACTS_LIST: {
    TITLE: 'Contracts'
  }
}
